<template>
  <div class="employee-panel flex flex-column">
    <div class="employee-panel-wrapper flex flex-row">
      <div class="left-panel flex-1 flex flex-column">
        <div class="project-data section">
          <border-style>
            <div class="project-statistics flex flex-row">
              <div class="flex-1 flex flex-row">
                <div class="statistics-icon cyan">
                  <i class="r2-icon-project"></i>
                </div>
                <div class="flex-1">
                  <div class="statistics-number ellipsis">{{projectInfo.principal}}</div>
                  <div class="statistics-type ellipsis">我负责的项目</div>
                </div>
              </div>
              <div class="divide-line"></div>
              <div class="flex-1 flex flex-row">
                <div class="statistics-icon blue">
                  <i class="r2-icon-project"></i>
                </div>
                <div class="flex-1">
                  <div class="statistics-number ellipsis">{{projectInfo.participate}}</div>
                  <div class="statistics-type ellipsis">我参与的在施项目</div>
                </div>
              </div>
              <div class="divide-line"></div>
              <div class="flex-1 flex flex-row">
                <div class="statistics-icon blue">
                  <i class="r2-icon-project"></i>
                </div>
                <div class="flex-1">
                  <div class="statistics-number ellipsis">{{projectInfo.recorded}}</div>
                  <div class="statistics-type ellipsis">我参与的备案项目</div>
                </div>
              </div>
            </div>
          </border-style>
        </div>
        <div class="flex-1 section">
          <border-style class="flex flex-column">
            <div class="width-full height-full flex flex-column">
              <div class="section-title">最近参与项目</div>
              <div class="flex-1 list-data flex flex-column">
                <div class="list-header flex flex-row">
                  <div class="project-name flex-1">项目名称</div>
                  <div class="project-manager">负责人</div>
                  <div class="project-stage">项目阶段</div>
                  <div class="project-create-time">立项时间</div>
                  <div class="project-update-time">最近修改时间</div>
                </div>
                <div class="list-body relative flex-1" v-loading="loadingProjectFile"
                     element-loading-background="rgba(0, 0, 0, 0)" element-loading-text="加载中">
                  <div class="absolute width-full height-full flex flex-column">
                    <template v-if="projectData.length">
                      <w-scrollbar wrap-style="overflow-x: hidden;" style="height: 100%;">
                        <div class="list-item flex flex-row" v-for="project in projectData" :key="project.prjId"
                             @click="previewProject(project)">
                          <div class="project-name flex-1 ellipsis">
                            <div class="project-name flex-1 flex flex-row">
                              <div class="file-icon folder"></div>
                              <div class="file-name ellipsis flex-1">{{project.prjName}}</div>
                            </div>
                          </div>
                          <div class="project-manager ellipsis">{{project.manager}}</div>
                          <div class="project-stage ellipsis">{{project | statusFilter}}</div>
                          <div class="project-create-time">{{project.createTime | formatDate}}</div>
                          <div class="project-update-time">{{project.modifyTime | formatDate}}</div>
                        </div>
                      </w-scrollbar>
                    </template>
                    <no-data v-else-if="!loadingProjectFile"></no-data>
                  </div>
                </div>
              </div>
            </div>
          </border-style>
        </div>
        <div class="flex-1">
          <border-style class="flex flex-column">
            <div class="width-full height-full flex flex-column">
              <div class="section-title">最近使用文件</div>
              <div class="flex-1 list-data flex flex-column" v-loading="loadingRecentFile"
                   element-loading-background="rgba(0, 0, 0, 0)" element-loading-text="加载中">
                <div class="list-body relative flex-1">
                  <div class="absolute width-full height-full flex flex-column">
                    <template v-if="recentFiles.length">
                      <w-scrollbar wrap-style="overflow-x: hidden;" style="height: 100%;">
                        <div class="list-item flex flex-row" v-for="item in recentFiles" :key="item.fileId"
                             @click="previewFile(item)">
                          <div class="project-name flex-1">
                            <template
                              v-if="item.suffix && (item.suffix + '').toUpperCase() === 'GTJXT'">
                              <div style="width: 32px;height: 32px;margin-right: 20px;">
                                <i
                                  :class="['file-icons', (item.fileProperties && item.fileProperties.projectType) ? 'icon_' + item.fileProperties.projectType : '', item.folder ? (item.fileType === 'share' ? 'folder__share' : 'folder') : '']"></i>
                              </div>
                            </template>
                            <template v-else>
                              <div style="width: 32px;height: 32px;margin-right: 20px;">
                                <i
                                  :class="['file-icons', (item.suffix==='gtjxt'||item.suffix==='GTJXT')? 'icon_':'icon_' + item.suffix,isGTJXT(item)?'icon_10000':'', (item.fileProperties && item.fileProperties.projectType) ? 'icon_' + item.fileProperties.projectType : '', item.folder ? (item.fileType === 'share' ? 'folder__share' : 'folder') : '', item.fileProperties.coProjectId ? 'xt': '']"></i>
                              </div>
                            </template>
                            <span class="file-name ellipsis">{{item.fileName}}</span>
                            <w-tag class="region-tag margin-left-10" size="mini" around v-if="item.workspaceType" @click.stop="previewFile(item)">
                              {{item.workspaceType}}
                            </w-tag>
                            <!--<w-tag class="region-tag margin-left-10" size="mini" around v-if="item.fileProperties && item.fileProperties.region">-->
                              <!--{{item.fileProperties.region}}-->
                            <!--</w-tag>-->
                          </div>
                          <div class="project-path ellipsis text-align-right">{{item.workspaceType}}{{item.filePath === '/' ? '' : item.filePath}}</div>
                          <div class="project-update-time text-align-right">{{item.latestUseTime | formatDate}}</div>
                        </div>
                      </w-scrollbar>
                    </template>
                    <no-data v-else-if="!loadingRecentFile"></no-data>
                  </div>
                </div>
              </div>
            </div>
          </border-style>
        </div>
      </div>
      <div class="right-panel">
        <div class="section todo-list">
          <border-style class="flex flex-column">
            <div class="section-title">待办事项</div>
            <div class="flex-1 enter-wrapper">
              <w-row class="height-full" type="flex" justify="space-between">
                <w-col>
                  <div class="enter-box">
                    <div class="statistics-icon orange" @click="toMessageCenter('3', 1)">
                      {{message.share}}
                    </div>
                    <div class="enter-text">分享消息</div>
                  </div>
                </w-col>
                <w-col>
                  <div class="enter-box">
                    <div class="statistics-icon blue" @click="toMessageCenter('1', 2)">
                      {{message.markup}}
                    </div>
                    <div class="enter-text">批注消息</div>
                  </div>
                </w-col>
                <w-col>
                  <div class="enter-box">
                    <div class="statistics-icon green" @click="toMessageCenter('2', 3)">
                      {{message.project}}
                    </div>
                    <div class="enter-text">项目消息</div>
                  </div>
                </w-col>
                <w-col>
                  <div class="enter-box">
                    <div class="statistics-icon cyan" @click="toMessageCenter('4', 4)">
                      {{message.enterprise}}
                    </div>
                    <div class="enter-text">企业消息</div>
                  </div>
                </w-col>
                <w-col>
                  <div class="enter-box">
                    <div class="statistics-icon blue" @click="toMessageCenter('7', 5)">
                      {{message.system}}
                    </div>
                    <div class="enter-text">系统消息</div>
                  </div>
                </w-col>
              </w-row>
            </div>
          </border-style>
        </div>
        <div class="section statistics-data">
          <border-style>
            <iframe :src="qydataUrl + '/integration/indexChart?type=personZbStat'" frameborder="0"
                    width="100%" height="100%" v-if="isLogin"></iframe>
            <no-data :text="`${initial ? '请求异常，请重新登录' : '加载中'}`" :show-icon="false" v-else></no-data>
          </border-style>
        </div>
        <div class="section statistics-data">
          <border-style>
            <iframe :src="qydataUrl + '/integration/indexChart?type=personPriceStat'" frameborder="0"
                    width="100%" height="100%" v-if="isLogin"></iframe>
            <no-data :text="`${initial ? '请求异常，请重新登录' : '加载中'}`" :show-icon="false" v-else></no-data>
          </border-style>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BorderStyle from './border-style'
import NoData from './no-data'
import Bus from '@/assets/utils/bus'
import {formatDate} from '@/assets/utils/Date'
import {mapMutations} from 'vuex'
import HomeService from '@/assets/service/home'
import ProjectService from '@/assets/service/r2Project'
import {qydataUrl} from '@/assets/js/config'

export default {
  name: 'employeePanel',
  components: {
    BorderStyle,
    NoData
  },
  props: {
    initial: {
      type: Boolean,
      default: false
    },
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      qydataUrl,
      projectInfo: {
        principal: 0,
        participate: 0,
        recorded: 0
      },
      loadingProjectFile: false,
      projectData: [],
      loadingRecentFile: false,
      recentFiles: [],
      message: {
        share: 0,
        markup: 0,
        project: 0,
        enterprise: 0,
        system: 0
      },
      startTime: 0
    }
  },
  filters: {
    statusFilter (obj) {
      if (obj.prjType === 1) {
        let objq = Object.assign({}, obj.prjStatus)
        let str = Object.keys(objq)[Object.values(objq).lastIndexOf(1)]
        str = str ? str.replace(/(资料|文件)/, '阶段') : ''
        obj.stage = str || '评估阶段'
        return str
      } else {
        return '其他工程'
      }
    },
    formatDate (time) {
      return formatDate(new Date(time), 'yyyy-MM-dd')
    }
  },
  mounted () {
    this.startTime = Date.now()
    this.queryTotalData()
    this.queryMessageNum()
    this.recentFile()
    this.recentProject()
    // Bus.$on('closeAllNotice', this.queryMessageNum)
  },
  beforeDestroy () {
    let duration = Math.floor((Date.now() - this.startTime) / 1000)
    this.sentLog(100118003, {duration})
  },
  methods: {
    ...mapMutations({
      setPath: 'project/SET_PATH'
    }),
    // 获取是不是项目空间中的GTJXT文件
    isGTJXT (item) {
      if (this.tabletype === 'projectList' && (item.suffix + '').toUpperCase() === 'GTJXT') {
        return true
      } else {
        return false
      }
    },
    // 查看项目详情
    previewProject ({prjId, prjName, recordStatus, editable, stage}) {
      this.sentLog(100118004)
      ProjectService.getPrjDetail({id: prjId}).then(res => {
        if (res.code === 200) {
          const data = res.data || {}
          if (data.prjName && data.recordStatus === 0) {
            let status = stage || '全部文件'
            if (+recordStatus === 1 || editable) {
              return
            }
            this.setPath(this.$route.path)
            this.$router.push({path: `/project/all/${prjId}/files/${status}`, query: {prjName}})
            if (this.$microAppRouter) {
              const projectDetailPath = `/project/all/${prjId}/files/${status}?prjName=${prjName}`
              sessionStorage.setItem('projectDetailPath', projectDetailPath)
              //  Vue组件中使用
              this.$microAppRouter.push({
                productCode: "gccs_base-paas", // 产品编码
                menuCode: "gccs.zjy-app.zjy_module_project_zsxmk_wcyd" // 菜单编码
                // applicationCode: "gccs_base-paas", // 可选：入口编码；同产品不同入口下有相同菜单时必传
                // path: `/project/all/${prjId}/files/${status}?prjName=${prjName}` // 可选：目标是微应用内部非默认页面时传入其路由
              })
            }
          } else {
            this.$message.error('抱歉找不到您的项目，可能已被重命名、备案或删除')
          }
        } else {
          this.$message.error('抱歉找不到您的项目，可能已被重命名、备案或删除')
        }
      }).catch((e) => {
        this.$message.error(e.message)
      })
    },
    // 查看最近使用文件
    previewFile (item) {
      this.sentLog(100118005)
      const {workspaceType, projectId, projectStage, filePath} = item
      let spaceType
      let path
      switch (workspaceType) {
        case '员工资料库':
          spaceType = 1
          path = '/space/files/list'
          break
        case '共享资料库':
          spaceType = 2
          path = '/enterprise/share'
          break
        case '项目库':
          spaceType = 3
          path = `/project/joined/${projectId}/files/${projectStage}?prjName=${filePath.split('/')[1]}`
          break
        case '备案项目库':
          spaceType = 3
          path = `/database/data/record/${projectId}/files/${projectStage}?prjName=${filePath.split('/')[1]}`
          break
        default:
      }
      this.directoryJump(Object.assign(item, {
        spaceType,
        path
      }))
    },
    // 跳转到消息中心
    toMessageCenter (type, messageType) {
      this.sentLog(100118006, {messageType})
      // Bus.$emit('showAllNotice')
      // window.messageTab = type
      //  Vue组件中使用
      this.$microAppRouter.push({
        productCode: "gccs_base-paas", // 产品编码
        menuCode: "pmpp.message-center.station-message-all" // 菜单编码
        // applicationCode: "gccs_base-paas", // 可选：入口编码；同产品不同入口下有相同菜单时必传
        // path: `/project/all/${prjId}/files/${status}?prjName=${prjName}` // 可选：目标是微应用内部非默认页面时传入其路由
      })
    },
    // 查询项目数量
    queryTotalData () {
      HomeService.queryEmployeeNum().then(res => {
        if (res.code === 200) {
          const {
            principal = 0,
            participate = 0,
            recorded = 0
          } = res.data || {}
          Object.assign(this.projectInfo, {
            principal,
            participate,
            recorded
          })
        } else {
          this.projectInfo = {
            principal: 0,
            participate: 0,
            recorded: 0
          }
        }
      }).catch(() => {
        this.projectInfo = {
          principal: 0,
          participate: 0,
          recorded: 0
        }
      })
    },
    // 查询各种未读消息数量
    queryMessageNum () {
      HomeService.queryMessageNum().then(res => {
        if (res.code === 200) {
          const {
            share = 0,
            markup = 0,
            project = 0,
            enterprise = 0,
            system = 0
          } = res.data || {}
          Object.assign(this.message, {
            share,
            markup,
            project,
            enterprise,
            system
          })
        } else {
          this.message = {
            share: 0,
            markup: 0,
            project: 0,
            enterprise: 0,
            system: 0
          }
        }
      }).catch(() => {
        this.message = {
          share: 0,
          markup: 0,
          project: 0,
          enterprise: 0,
          system: 0
        }
      })
    },
    // 查询最近使用文件列表
    recentFile () {
      this.loadingRecentFile = true
      const startTime = Date.now()
      HomeService.recentFile().then(res => {
        this.loadingRecentFile = false
        if (res.code === 200) {
          this.sentLog(100118012, {duration: ((Date.now() - startTime) / 1000).toFixed(2)})
          this.recentFiles = res.data || []
          // this.recentFiles.unshift({
          //   fileId: '281847c6aba24e78bf40f7f0036df255',
          //   fileName: 'develop.jpg',
          //   filePath: '/t100项目',
          //   fileProperties: {},
          //   latestUseTime: 1628046721000,
          //   projectId: '5689342a275548df9a4a4fa4ed5bc285',
          //   projectStage: '全部文件',
          //   suffix: 'jpg',
          //   workspaceId: '',
          //   workspaceType: '备案库'
          // })
        } else {
          this.recentFiles = []
        }
      }).catch(() => {
        this.loadingRecentFile = false
        this.recentFiles = []
      })
    },
    // 查询最近参与项目列表
    recentProject () {
      this.loadingProjectFile = true
      const startTime = Date.now()
      HomeService.recentProject().then(res => {
        this.loadingProjectFile = false
        if (res.code === 200) {
          this.sentLog(100118011, {duration: ((Date.now() - startTime) / 1000).toFixed(2)})
          this.projectData = res.data || []
        } else {
          this.projectData = []
        }
      }).catch(() => {
        this.loadingProjectFile = false
        this.projectData = []
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .employee-panel {
    width: 100%;
    height: 100%;
    position: relative;

    .employee-panel-wrapper {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }

    .section {
      padding-bottom: 12px;

      .project-data {
        height: 104PX;
      }
    }

    .section-title {
      padding: 12PX 24PX 21PX 24PX;
      height: 24PX;
      font-size: 14px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 24PX;
    }

    .statistics-icon {
      width: 48PX;
      height: 48PX;
      border-radius: 50%;
      text-align: center;
      line-height: 46PX;
      margin: 0 auto;

      i {
        font-size: 24px !important;
      }

      &.cyan {
        background: linear-gradient(360deg, #1FF1DC 0%, #00C0CF 100%);
      }

      &.blue {
        background: linear-gradient(360deg, #479DFF 0%, #0068FF 100%);
      }

      &.green {
        background: #2CCC4A;
      }

      &.orange {
        background: #FF7C48;
      }
    }

    .left-panel {
      .project-data {
        .project-statistics {
          padding: 21PX 0;

          .divide-line {
            width: 1px;
            height: 50PX;
            background: rgba(255, 255, 255, 0.15);
            margin: 6PX 0;
          }

          .statistics-icon {
            margin: 7PX 24PX;
          }

          .statistics-number {
            font-size: 32PX;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 40PX;
            height: 40PX;
            font-family: Arial !important;
          }

          .statistics-type {
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.8);
            line-height: 22PX;
            height: 22PX;
          }
        }
      }

      .list-data {
        overflow: hidden;
        margin-bottom: 14PX;

        .list-header {
          padding: 0 23PX 12PX 25PX;

          & > div {
            height: 20PX;
            font-size: 12px;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.55);
            line-height: 20PX;
            padding-right: 10PX;

            &:last-child {
              padding-right: 0;
            }
          }
        }

        .project-name {
          font-size: 14px;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          overflow: hidden;
          color: #ffffff;

          .file-icon {
            width: 32px;
            height: 32px;
            background: url("~@/assets/images/project/folder.png") no-repeat center center;
            background-size: contain;
            margin-right: 20px;
          }

          .file-name {
            display: inline-block;
            color: #ffffff;
          }

          .region-tag {
            /*width: 40PX;*/
            height: 20PX;
            border-radius: 16PX;
            border: 1px solid rgba(255, 255, 255, 0.15);
            background: transparent;
            font-size: 12px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.55);
            line-height: 18PX;
            text-align: center;
          }
        }

        .project-path {
          width: 300PX;
        }

        .project-manager {
          width: 127PX;
        }

        .project-stage {
          width: 141PX;
        }

        .project-create-time {
          width: 138PX;
        }

        .project-update-time {
          width: 90PX;
        }

        .list-item {
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          color: #ffffff;

          & > div {
            padding-right: 10PX;

            &:last-child {
              padding-right: 0;
            }
          }

          padding: 0 23PX 0 25PX;
          height: 52PX;
          line-height: 52PX;
          font-weight: 400;
          font-size: 12px;
          cursor: pointer;

          &:hover {
            background: rgba(0, 0, 0, 0.3);
          }

          .project-create-time {
            font-family: Arial !important;
          }

          .project-update-time {
            font-family: Arial !important;
          }
        }
      }
    }

    .right-panel {
      padding-left: 12PX;
      width: 600PX;

      .todo-list {
        height: 164PX;

        .enter-box {
          .statistics-icon {
            width: 46PX;
            height: 46PX;
            line-height: 46PX;
            font-weight: 500;
            font-size: 18PX;
            font-family: Arial !important;
            cursor: pointer;
          }

          .enter-text {
            text-align: center;
            height: 22PX;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.8);
            line-height: 22PX;
            margin-top: 11PX;
          }
        }
      }

      .statistics-data {
        height: 150PX;
      }
    }

  }
</style>
